/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkType } from '../../models/work-type';

export interface WorkTypesControllerFindAllPublic$Params {
}

export function workTypesControllerFindAllPublic(http: HttpClient, rootUrl: string, params?: WorkTypesControllerFindAllPublic$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<WorkType>>> {
  const rb = new RequestBuilder(rootUrl, workTypesControllerFindAllPublic.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<WorkType>>;
    })
  );
}

workTypesControllerFindAllPublic.PATH = '/work-types';
